import React, { useReducer, useEffect, useRef } from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import axios from "axios";

import URL from "../../common/variables";
import { parseDateString } from "../../common/functions";

import { MapsReducer } from "./MapsReducer";

import "./maps.scss";

const Maps = () => {
  const refMap = useRef(undefined);
  const initialState = {
    count: 0,
    next: null,
    previous: null,
    viewport: {
      center: [19.432608, -99.133209], // Mexico city
      zoom: 4,
    },
    data: [],
  };
  const [state, dispatch] = useReducer(MapsReducer, initialState);

  const map = document.getElementById("map");
  const nodes = document.querySelectorAll(".lajornada__map");
  const nodesData = [];

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", () => {
      map.style.display = "none";
    });

    nodes.forEach((element) => {
      const {
        lon,
        lat,
        zoom,
        title,
        date,
        catSlug,
        slug,
      } = element.childNodes[1].dataset;

      element.addEventListener("click", handleClickScroll, false);

      nodesData.push({
        zoom: Number(zoom),
        title,
        date,
        catSlug,
        slug,
        geolocation: [Number(lat), Number(lon)],
      });
    });

    dispatch({
      type: "SETUP_INITIAL_MAP",
      center: nodesData[0].geolocation,
      zoom: nodesData[0].zoom,
      data: nodesData,
    });
  }, []);

  const handleClickScroll = (event) => {
    event.preventDefault();

    map.style.display = "block";
    map.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

    return false;
  };

  const handleViewportChanged = (obj) => {
    const north = refMap.current.leafletElement.getBounds().getNorth();
    const south = refMap.current.leafletElement.getBounds().getSouth();
    const east = refMap.current.leafletElement.getBounds().getEast();
    const west = refMap.current.leafletElement.getBounds().getWest();
    const inBbox = [west, south, east, north].join(",");

    axios.get(`${URL}/articles/geo/?in_bbox=${inBbox}`).then((response) => {
      const { count, next, previous, results } = response.data;
      const { center, zoom } = obj;

      dispatch({
        type: "GET_MAP_DATA",
        count,
        next,
        previous,
        results,
        center,
        zoom,
      });
    });
  };

  return (
    <Map
      onViewportChanged={handleViewportChanged}
      ref={refMap}
      viewport={state.viewport}
    >
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {state.data.map((element, index) => {
        const { title, date, catSlug, slug } = element;
        const href = `/notas/${parseDateString(date)}/${catSlug}/${slug}/`;

        return (
          <Marker position={element.geolocation} key={index}>
            <Popup>
              <a className="time-pill text-white mr-1" href={href}>
                <i className="fas fa-clock mr-1"></i>
                {date}
              </a>
              <a href={href}>{title}</a>
            </Popup>
          </Marker>
        );
      })}
    </Map>
  );
};

export default Maps;
